import { createAction } from 'redux-actions';

import types from './types';

const initialize = createAction(types.INITIALIZE);
const setInitialized = createAction(types.SET_INITIALIZED);
const setSegmentId = createAction(types.SET_SEGMENT_ID);
const setSettings = createAction(types.SET_SETTINGS);

export default {
    initialize,
    setInitialized,
    setSegmentId,
    setSettings,
};
